package com.milta.core.localization.translations.sq

import com.milta.core.localization.ImportsStrings

internal val Imports = ImportsStrings(
    titlePhoto = "Importo — Foto",
    titlePdf = "Importo — PDF",
    titleSpreadsheet = "Importo — Excel / CSV",
    fileSentSuffix = "dërguar tani",
    fileWaitingConnectionLabel = "duke pritur lidhjen",
    analysingTitle = "Duke lexuar dokumentin…",
    analysingSubtitle = "Nxjerrja e dërgesave mund të zgjasë disa sekonda.",
    analysingSubtitlePdf = "Claude Haiku nxjerr dërgesat — kjo mund të zgjasë disa sekonda për një PDF të skanuar.",
    stepFileSent = "Skedari u dërgua",
    stepExtracting = "Nxjerrja e fushave",
    stepReview = "Rishikim para shtimit",
    successTitle = "Dërgesa u zbulua",
    successSubtitle = "Kontrolloni informacionin para se ta shtoni në rrugë.",
    addToRouteButton = "Shto në rrugë",
    scanAnotherButton = "Skano një dokument tjetër",
    partialTitle = "Pothuajse i plotë",
    partialSubtitle = "Një fushë nuk mund të lexohej në dokument.",
    missingFieldPlaceholder = "Të plotësohet…",
    partialBannerText = "Disa informacione nuk mund të lexoheshin. Mund ta vlerësoni si është dhe t'i plotësoni më vonë, ose të ridërgoni një dokument më të qartë.",
    retryFileButton = "Ridërgo një skedar tjetër",
    validateAndContinueButton = "Vlerëso dhe vazhdo",
    errorTitleUnreadable = "Dokument i palexueshëm",
    errorTitleMissingFields = "Informacioni nuk u gjet",
    errorTitleNetworkError = "Problem gjatë analizës",
    errorTitleGeneric = "Analiza dështoi",
    errorSubtitle = "Nuk mundëm të zbulojmë ndonjë dërgesë në këtë skedar.",
    errorBannerSuffixUnreadable = "imazhi shumë i errët ose teksti i prerë. Bëni një foto të kornizuar mirë dhe të ndriçuar mirë, ose dërgoni një skedar më të qartë.",
    errorBannerSuffixMissingFields = "nuk u gjet asnjë informacion i përdorshëm. Kontrolloni përmbajtjen e skedarit ose dërgoni një tjetër.",
    errorBannerSuffixNetworkError = "shërbimi i analizës hasi një problem rrjeti. Provoni përsëri pas pak.",
    errorBannerSuffixGeneric = "ndodhi një gabim i papritur gjatë analizës. Provoni përsëri ose dërgoni një skedar tjetër.",
    retryWithNewFileButton = "Provo përsëri me një skedar tjetër",
    manualEntryButton = "Fut manualisht",
    newDocumentButton = "Importo një dokument të ri",
    serviceUnavailableTitle = "Shërbimi përkohësisht jo në dispozicion",
    serviceUnavailableSubtitle = "Analiza automatike nuk përgjigjet për momentin.",
    serviceUnavailableBanner = "Provoni përsëri pas pak, ose plotësoni dërgesën manualisht ndërkohë.",
    offlineTitle = "Jeni jashtë linje",
    offlineSubtitle = "Skedari juaj është gati, por nuk është dërguar ende.",
    offlineBanner = "Rilidhuni me internetin, pastaj rinisni analizën. Asgjë nuk u dërgua në server — asgjë nuk u zbrit nga krediti juaj IA.",
    retryOfflineButton = "Provo përsëri — pa lidhje",
    unsupportedFormatBanner = "Format skedari i pasuportuar. Zgjidhni një foto, PDF ose skedar Excel/CSV.",
    validationTitle = "Rishikoni dërgesat",
    fileRejectedTitle = "Skedari nuk u dërgua",
    fileRejectedSubtitle = "Zgjidhni një skedar tjetër për të vazhduar.",
    bannerFileRequired = "nuk u zgjodh asnjë skedar. Zgjidhni një skedar PDF për të vazhduar.",
    bannerInvalidPdfFormat = "format i pasuportuar. Këtu pranohen vetëm skedarë PDF.",
    bannerFileTooLarge = "skedar shumë i madh. Zgjidhni një skedar PDF më të lehtë.",
    chooseAnotherFileButton = "Zgjidh një skedar tjetër",
    processingCanLeaveNote = "Skedari juaj u dërgua. Mund ta lini këtë ekran, analiza vazhdon. Importin do ta gjeni te „Importo dërgesat”.",
    uploadingPhotoStep = "Duke dërguar foton",
    uploadingFileStep = "Duke dërguar skedarin",
    photoSentStep = "Fotoja u dërgua",
    uploadProgress = "%1 nga %2",
    uploadingPhotoBanner = "Dërgimi në vazhdim. Mbajeni këtë ekran të hapur deri në fund të dërgimit: analiza fillon sapo të merret fotoja.",
    uploadingFileBanner = "Dërgimi në vazhdim. Mbajeni këtë ekran të hapur deri në fund të dërgimit: analiza fillon sapo të merret skedari.",
    cancelUploadButton = "Anulo dërgimin",
    cancelImportButton = "Anulo importin",
    cancelImportDialogTitle = "Ta anuloni këtë import?",
    cancelImportAnalysingScanMessage = "Analiza ndalet menjëherë dhe asnjë dorëzim nuk do t'i shtohet turit tuaj. Analiza e nisur tashmë mbetet e zbritur nga krediti juaj IA.",
    cancelImportAnalysingFileMessage = "Analiza ndalet menjëherë dhe asnjë dorëzim nuk do t'i shtohet turit tuaj. Analiza e nisur tashmë mbetet e zbritur nga krediti juaj IA.",
    cancelImportConfirmButton = "Po, anulo importin",
    continueAnalysisButton = "Vazhdo analizën",
    cancelImportReviewMessage = "Dorëzimet e zbuluara (%s) fshihen dhe asnjë nuk i shtohet turit tuaj. Ktheheni te zgjedhja e burimit.",
    cancelImportReviewMessageSingle = "Dorëzimi i zbuluar fshihet dhe nuk i shtohet turit tuaj. Ktheheni te zgjedhja e burimit.",
    continueReviewButton = "Vazhdo kontrollin",
    importCancelledNotice = "Importi u anulua. Nuk u shtua asnjë dorëzim.",
    serviceUnavailableRetryBanner = "Skedari juaj ruhet. Rinisni analizën pa e dërguar përsëri, ose plotësoni dërgesën manualisht ndërkohë.",
    serviceUnavailableExhaustedBanner = "Ky dokument nuk mund të analizohej. Shtoni dërgesat manualisht, ose rinisni me një dokument të ri.",
    errorTitleTooLong = "Dokument shumë i gjatë",
    errorSubtitleTooLong = "Ky dokument përmban shumë dërgesa për t'u analizuar njëherësh.",
    errorBannerSuffixTooLong = "ndajeni në disa skedarë më të shkurtër, ose futini dërgesat manualisht.",
    errorTitleTooLarge = "Dokument shumë i madh",
    errorSubtitleTooLarge = "Ky dokument e tejkalon madhësinë që analiza mund të përpunojë.",
    errorBannerSuffixTooLarge = "zvogëlojeni ose ndajeni në disa skedarë, ose futini dërgesat manualisht.",
    errorTitleNoDeliveries = "Nuk u gjet asnjë dërgesë",
    errorSubtitleNoDeliveries = "Dokumenti u lexua, por nuk u gjet asnjë dërgesë në të.",
    errorBannerSuffixNoDeliveries = "kontrolloni që përmban një listë dërgesash, ose futini manualisht.",
    errorTitleSourceExpired = "Skedari ka skaduar",
    errorSubtitleSourceExpired = "Ky skedar nuk është më i disponueshëm për një analizë të re.",
    errorBannerSuffixSourceExpired = "zgjidheni përsëri për të rinisur analizën.",
    errorTitleOriginRouteDeleted = "Importi u anulua",
    errorSubtitleOriginRouteDeleted = "Turi i origjinës u fshi: ky import është anuluar.",
    errorBannerSuffixOriginRouteDeleted = "importi u anulua, nuk u shtua asnjë dorëzim.",
    activeImportHeader = "Import në vazhdim",
    activeImportAnalysingPill = "Analizë në vazhdim",
    activeImportFailedPill = "Analiza dështoi",
    activeImportReadyPill = "Gati për miratim",
    activeImportRunningNote = "Vetëm një import njëherësh. Prisni përfundimin e analizës, ose anulojeni, për të importuar një dokument tjetër.",
    activeImportFailedNote = "Vetëm një import njëherësh. Rinisni ose anuloni këtë import për të importuar një dokument tjetër.",
    activeImportReadyNote = "Dërgesat e importuara janë gati. Prekni për t'i miratuar.",
    activeImportRunningOtherRouteNote = "Po analizohet një import për turin e %s. Prekni për të hapur këtë tur. Prisni përfundimin e analizës, ose anulojeni, për të importuar një dokument tjetër.",
    activeImportReadyOtherRouteNote = "Dërgesat e turit të %s janë gati. Prekni për të hapur këtë tur dhe për t'i miratuar.",
    activeImportFailedOtherRouteNote = "Importi i turit të %s dështoi. Rinisni ose anuloni këtë import për të importuar një dokument tjetër.",
    activeImportRunningNewRouteNote = "Po analizohet një import për një tur të ri. Prekni për të vazhduar krijimin e tij. Prisni përfundimin e analizës, ose anulojeni, për të importuar një dokument tjetër.",
    activeImportReadyNewRouteNote = "Dërgesat e turit të ri janë gati. Prekni për të vazhduar krijimin e tij dhe për t'i miratuar.",
    activeImportFailedNewRouteNote = "Importi i turit të ri dështoi. Rinisni ose anuloni këtë import për të importuar një dokument tjetër.",
    activeImportRouteLink = "Turi i %s",
    activeImportNewRouteLink = "Tur i ri (në krijim)",
    weekdayNamesInText = listOf("e hënë", "e martë", "e mërkurë", "e enjte", "e premte", "e shtunë", "e diel"),
)
